import { Entity } from 'src/app/modules/portfolio/models/entity';
import { EntityResponseWithNestedObjectsAuditable } from '../../../../web-api-client';
import { mapEntityTypeFromResponse } from '../entity-type/map-entity-type-from-response';
import { mapResidencyJurisdictionFromResponse } from '../residency-jurisdiction/map-residency-jurisdiction-from-response';

export const mapEntityFromResponseNested = (
  response: EntityResponseWithNestedObjectsAuditable
): Entity => ({
  entityId: response.entityId,
  clientId: response.client?.clientId,
  residencyJurisdictionId:
    response.residencyJurisdiction?.residencyJurisdictionId,
  residencyJurisdiction: mapResidencyJurisdictionFromResponse(
    response.residencyJurisdiction!
  ),
  entityTypeId: response.entityType?.entityTypeId,
  entityType: mapEntityTypeFromResponse(response.entityType!),
  name: response.name,
  description: response.description ?? '',
  isActive: response.isActive ?? false,
  modified: response.modified,
});
